import React from 'react'
import styled from 'styled-components'

const SvgWrapper = styled.svg`
  .cls-1 {
    fill: url(#linear-gradient);
  }
  .cls-2 {
    fill: url(#linear-gradient-2);
  }
  .cls-3 {
    fill: url(#linear-gradient-3);
  }
  .cls-4 {
    fill: url(#linear-gradient-4);
  }
  .cls-5 {
    fill: url(#linear-gradient-5);
  }
  .cls-6 {
    fill: url(#linear-gradient-6);
  }
  .cls-10,
  .cls-11,
  .cls-12,
  .cls-13,
  .cls-7,
  .cls-8,
  .cls-9 {
    fill-rule: evenodd;
  }
  .cls-7 {
    fill: url(#linear-gradient-7);
  }
  .cls-8 {
    fill: url(#linear-gradient-8);
  }
  .cls-9 {
    fill: url(#linear-gradient-9);
  }
  .cls-10 {
    fill: url(#linear-gradient-10);
  }
  .cls-11 {
    fill: url(#linear-gradient-11);
  }
  .cls-12 {
    fill: url(#linear-gradient-12);
  }
  .cls-13 {
    fill: url(#linear-gradient-13);
  }
  .cls-14 {
    fill: url(#linear-gradient-14);
  }
`

const ZaatLogoSvg = () => (
  <SvgWrapper width="100" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2581.86 441.27">
    <defs><linearGradient id="linear-gradient" x1="376.72" y1="283.93" x2="697.45" y2="283.93" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#2ab640"/><stop offset="1" stopColor="#54cf61"/></linearGradient
    ><linearGradient id="linear-gradient-2" x1="744.65" y1="283.93" x2="1065.38" y2="283.93" xlinkHref="#linear-gradient"/><linearGradient id="linear-gradient-3" x1="1124.67" y1="237.94" x2="1369.15" y2="237.94" xlinkHref="#linear-gradient"/><linearGradient id="linear-gradient-4" x1="1557.95" y1="222.51" x2="1878.68" y2="222.51" xlinkHref="#linear-gradient"/><linearGradient id="linear-gradient-5" x1="1925.88" y1="283.93" x2="2246.61" y2="283.93" xlinkHref="#linear-gradient"/><linearGradient id="linear-gradient-6" x1="2260.53" y1="291.8" x2="2581.86" y2="291.8" xlinkHref="#linear-gradient"/><linearGradient id="linear-gradient-7" x1="0" y1="219.9" x2="340.16" y2="219.9" xlinkHref="#linear-gradient"/><linearGradient id="linear-gradient-8" x1="1435.86" y1="390.5" x2="1508.57" y2="390.5" xlinkHref="#linear-gradient"/></defs><title>logo zaat</title><path class="cls-1" d="M697.45,433.4h-66V377.73h-1.21q-12.12,29-39.94,46.29t-66,17.25a154.93,154.93,0,0,1-53.25-9.68,136.72,136.72,0,0,1-47.51-29.35q-20.88-19.67-33.89-49t-13-69.29q0-33.89,11.8-62.93a144.49,144.49,0,0,1,33.29-49.93,154.7,154.7,0,0,1,50.83-32.67Q502,126.6,537.69,126.59q35.09,0,64.75,11.5T653,170.47q20.88,20.86,32.68,50.22t11.8,65.66ZM537.69,374.1q39.94,0,63.84-25.12t23.91-65.05q0-39.94-23.91-65.05t-63.84-25.12q-39.95,0-64.14,25.12t-24.21,65.05q0,39.94,24.21,65.05T537.69,374.1Z"/><path class="cls-2" d="M1065.38,433.4h-66V377.73H998.2q-12.11,29-39.94,46.29t-66,17.25a155,155,0,0,1-53.25-9.68,136.72,136.72,0,0,1-47.51-29.35q-20.87-19.67-33.88-49t-13-69.29q0-33.89,11.8-62.93a144.33,144.33,0,0,1,33.28-49.93,154.7,154.7,0,0,1,50.83-32.67q29.36-11.81,65.06-11.81,35.08,0,64.75,11.5t50.53,32.38a148.1,148.1,0,0,1,32.67,50.22q11.81,29.37,11.81,65.66ZM905.62,374.1q39.93,0,63.84-25.12t23.9-65.05q0-39.94-23.9-65.05t-63.84-25.12q-39.95,0-64.15,25.12t-24.21,65.05q0,39.94,24.21,65.05T905.62,374.1Z"/><path class="cls-3" d="M1369.15,318.42q0,30.87-8.77,54.16T1335.26,411a106.35,106.35,0,0,1-38.73,22.69q-22.4,7.55-49.62,7.56t-49.62-7.56A106.26,106.26,0,0,1,1158.56,411q-16.33-15.12-25.11-38.44t-8.78-54.16V34.61h72v99.85H1351v65.35H1196.68V318.42q0,30.27,13.92,43t36.31,12.71q22.38,0,36.31-12.41t13.92-43.27v-7.86h72Z"/><path class="cls-4" d="M1878.68,281.51q0,36.32-11.8,66T1834.2,398q-20.87,20.88-50.53,32.07t-64.75,11.2q-35.72,0-65.05-11.8A154.88,154.88,0,0,1,1603,396.79a144.29,144.29,0,0,1-33.28-49.92Q1558,317.82,1558,283.93q0-39.94,13-69.29t33.89-49a136.84,136.84,0,0,1,47.51-29.34,155,155,0,0,1,53.25-9.69q33.89,0,59.61,13.32t40.24,36.3h1.21V3.75h72ZM1718.92,374.1q39.94,0,63.85-25.12t23.9-65.05q0-39.94-23.9-65.05t-63.85-25.12q-39.93,0-64.14,25.12t-24.21,65.05q0,39.94,24.21,65.05T1718.92,374.1Z"/><path class="cls-5" d="M2001.52,309.35v1.21q7.26,30.27,29.35,47.8t56,17.55q48.41,0,70.8-28.44h76.85a142.44,142.44,0,0,1-55.67,68.38q-38.73,25.42-92,25.42-35.71,0-65.06-11.8A155,155,0,0,1,1971,396.79a144.43,144.43,0,0,1-33.28-49.92q-11.81-29.06-11.8-62.94t11.8-62.93A144.47,144.47,0,0,1,1971,171.07a154.8,154.8,0,0,1,50.83-32.67q29.36-11.81,65.06-11.81,35.08,0,64.75,11.81t50.53,32.67A149,149,0,0,1,2234.81,221q11.79,29,11.8,62.93v25.42ZM2086.85,192q-32.08,0-53.56,15.73t-30,43v1.21h167v-1.21q-8.47-27.24-30.26-43T2086.85,192Z"/><path class="cls-6" d="M2377.93,441.27l-117.4-298.95h78.67l82.3,231.17h1.21L2505,142.32h76.85l-117.4,299Z"/><path class="cls-7" d="M107,360.51l19.83-24.18L336.34,79.75l2.53-3.1V0H.75V79.75H232.09l-58.56,71.34L2.09,360.51,0,363.07v76.65H42l298.12.07V360.51Z"/><path class="cls-8" d="M1437.34,398.32c5.93,24.27,24.56,40.8,45.45,36s29.91-27.62,24-51.89-28.19-40-45.45-36S1431.41,374.05,1437.34,398.32Zm14.52-24.46c1.53-2.4,4.43-3.31,6.5-2s2.49,4.29,1,6.7-4.44,3.32-6.5,2S1450.33,376.28,1451.86,373.86Zm10.57-21.51c5.48-2.34,11.39-.94,13.21,3.15s-1.15,9.28-6.63,11.62-11.4.93-13.22-3.15S1457,354.69,1462.43,352.35Z"/>
  </SvgWrapper>
)

export default ZaatLogoSvg
